import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { CampaignSelectorProxy } from '@bingads-webui-campaign-react/campaign-adgroup-selector-control';

import { withUiBlock } from '@bingads-webui/uiblocker';
import template from './create-negative-keywords.pug';

globalContext.require('module/app/layout/index'); // eslint-disable-line no-unused-vars
globalContext.require('component/double-list-box/ko/doubleListBoxBinding'); // eslint-disable-line no-unused-vars
const help = globalContext.require('component/help/index');
const jsData = globalContext.require('component/js-data-campaign/index');
const edm = globalContext.requireDefault('component/edm-campaign/index');
const campignSelectori18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/campaign-adgroup-selector');
const appConfig = globalContext.require('component/config/index');

const permissions = appConfig.get('Permissions');


class CreateNegativeKeywordAssociationViewModel {
  constructor({
    gridType,
    i18n,
    scope,
    showSelector,
    accountLevel,
  }) {
    this.fetchListsUrl = `/campaign/NegativeKeywordLibrary/LoadLibrariesByAccount?aid=${$.advertiser.getUrlParameter('aid')}&cid=${$.advertiser.getUrlParameter('cid')}&uid=${$.advertiser.getUrlParameter('uid')}`;
    this.selectorControl = ko.observable();
    this.selectedCampaignId = ko.observable();
    this.selectedAdgroupId = ko.observable();
    this.selectorError = ko.observable();
    this.selectedLists = ko.observableArray();
    this.scope = this.createSelectorScopeObject(scope);
    this.showAdgroupSelector = gridType === 'adgroup';
    this.showCampaignSelector = !scope.values.campaignId;
    this.showSelector = showSelector;
    this.accountLevel = accountLevel;
    this.selectorLabel = this.showSelector ?
      '' :
      i18n.getString(_TL_('CampaignAdGroupSelector_SelectCampaign'));
    this.showSelectorErrorMessage = ko.observable(true);
    this.selectorErrorMessage = ko.observable('');
    this.shouldEnableSave = ko.computed(() => this.selectedCampaignId());
    this.multiSelectOptions = {
      strings: {
        sourceItems: i18n.getString('NegativeKeywordList_Association_AvailableLists'),
        selectedItems: i18n.getString('NegativeKeywordList_Association_SelectedLists'),
        select: i18n.getString('DoubleListBox_Select'),
        deselect: i18n.getString('DoubleListBox_DeselectAll'),
        filterWatermark: i18n.getString('DoubleListBox_Search'),
      },
    };
    this.$errors = ko.observableArray();
    this.multiSelect = false;
    this.selectedCampaigns = ko.observable();
    this.selectedCampaigns.subscribe((newValue) => {
      this.selectedCampaignId(newValue ? newValue.Id : null);
    });
    this.allLists = _.bind(this.getLists, this);
  }

  createSelectorScopeObject(scope) {
    const scopeObject = { currentScope: 'account' };

    if (scope.values.adGroupId) {
      scopeObject.currentScope = 'adgroup';
      scopeObject.adgroup = { Id: scope.values.adGroupId };
    }
    if (scope.values.campaignId) {
      scopeObject.currentScope = 'campaign';
      scopeObject.campaign = { Id: scope.values.campaignId };
    }
    return scopeObject;
  }

  getLists = (request, callback) => {
    if (!this.cache) {
      $.advertiser.ajaxPost({
        url: this.fetchListsUrl,
        onSuccess: (data) => {
          if (data) {
            this.cache = { items: data, total: data.length };
            callback(null, this.cache);
          } else {
            this.cache = { items: [], total: 0 };
            callback(null, this.cache);
          }
        },
      });
    } else {
      callback(null, this.cache);
    }
  };
}

export class CreateNegativeKeywordAssocationView extends Backbone.View {
  initialize({
    gridType, i18n, scope, gridView,
  }) {
    this.i18n = i18n;
    this.gridType = gridType;
    this.scope = scope;
    this.viewModel = new CreateNegativeKeywordAssociationViewModel({
      gridType,
      i18n,
      scope,
      showSelector: true,
      accountLevel: true,
    });
    this.gridView = gridView;
    this.$errors = this.viewModel.$errors;
  }

  get events() {
    return {
      'click #btnSave': 'save',
      'click #btnCancel': 'cancel',
    };
  }

  onCampaignSelect(selectedItem) {
    if (_.has(selectedItem, 'Id')) {
      this.viewModel.selectedCampaignId(selectedItem);
      this.viewModel.selectorError('');
    } else {
      // eslint-disable-next-line no-console
      console.warn('empty selectedItem');
    }
  }


  render() {
    let selectorView = null;
    if (this.viewModel.scope.currentScope === 'account') {
      let optionalCampaignFilter = '(CampaignSubType ne Enum.CampaignSubType\'ShoppingSmartAds\' and CampaignType ne Enum.CampaignType\'Audience\')';
      if (permissions.dynamic && permissions.dynamic.HotelCampaign) {
        optionalCampaignFilter += 'and (CampaignType ne Enum.CampaignType\'Hotel\')';
      }
      if (permissions.dynamic && permissions.dynamic.AccountNegativeKeywords && !permissions.IsNKWListAssociationAllowed) {
        optionalCampaignFilter += 'and (CampaignType ne Enum.CampaignType\'PerformanceMax\')';
      }
      selectorView = new CampaignSelectorProxy({
        withUiBlocker: withUiBlock,
        jsData,
        edmCampaign: edm,
        i18n: campignSelectori18n,
        optionalCampaignFilter,
      }).getCampaignSelectorView().render();

      selectorView.on('selected-adgroup', (selectedItem) => {
        this.viewModel.showSelector = false;
        this.onAdGroupSelect(selectedItem);
      });
      selectorView.on('selected-campaign', (selectedItem) => {
        this.viewModel.showSelector = false;
        this.onCampaignSelect(selectedItem);
      });
    } else {
      this.viewModel.selectedCampaignId(this.viewModel.scope.campaign);
      this.viewModel.accountLevel = false;
    }

    this.$el.html(template({
      i18n: this.i18n,
      appendLearnMoreLink: help.appendLearnMoreLink,
      $errors: this.viewModel.$errors,
      showSelector: this.viewModel.showSelector,
      accountLevel: this.viewModel.accountLevel,
      customerId: this.scope.values.cid,
      userId: this.scope.values.uid,
      accountId: this.scope.values.aid,
    }));
    ko.applyBindings(this.viewModel, this.el);

    if (this.viewModel.scope.currentScope === 'account') {
      this.$('.new-campaign-adgroup-selector').append(selectorView.el);
    }
    return this;
  }

  save() {
    const lists = this.viewModel.selectedLists();
    const ids = [];
    const campaignId = this.viewModel.selectedCampaignId().Id;

    _.each(lists, (item) => {
      ids.push(item.Id);
    });

    if (ids.length) {
      return this.createOnSaveLibraryAssociation({
        campaignId,
        libraryIds: ids,
        successHandler: () => {
          this.trigger('save');
          this.trigger('addNegativeKeywordsListsComplete');
        },
        el: this.el,
      });
    } else if (!ids.length) {
      const noListSelectedErr = this.i18n.getString('NegativeKeywordList_Association_NoListSelected');
      if (!_.contains(this.viewModel.$errors(), noListSelectedErr)) {
        this.viewModel.$errors.push(this.i18n.getString('NegativeKeywordList_Association_NoListSelected'));
      }
      return null;
    }
    return null;
  }

  findFailedEntries = (data) => {
    const failedEntries = [];

    _.each(data, (entry) => {
      const { errors } = entry;

      if (errors && errors.length > 0) {
        failedEntries.push(entry);
      }
    });

    return failedEntries.length > 0 ? failedEntries : null;
  };

  createOnSaveLibraryAssociation = ({
    campaignId, libraryIds, successHandler, el,
  }) => {
    const data = [];

    _.each(libraryIds, (id) => {
      data.push({
        SharedEntityId: id,
        EntityId: campaignId,
      });
    });

    return jsData.SharedEntityAssociation.createMany(data, { adapter: 'bulk', cacheResponse: false })
      .then(() => {
        successHandler();
      }).finally(withUiBlock(el));
  };

  cancel() {
    this.trigger('addNegativeKeywordsListsComplete');
  }

  remove() {
    ko.cleanNode(this.$el[0]);
    this.$el.hide();
    super.remove();
  }
}
